import { SelectField } from '@/components';
import {
  type ProjectSearchFormType,
  formulaTrendConditionEnum,
  formulaTrendConditionLabelModifier,
} from '@/features/search/_models/projects-search';
import { isTrendFieldDisabled } from '@/features/search/_utils/project-amount-search';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const options = formulaTrendConditionEnum.options.map((value) => {
  return {
    value,
    label: formulaTrendConditionLabelModifier[value],
  };
});

type Props = {
  index: number;
};

export const TrendConditionField: FC<Props> = ({ index }) => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<ProjectSearchFormType>();
  const baseAmountYear = useWatch({
    control,
    name: `formulaConditions.${index}.baseAmountYear`,
  });
  const targetAmountYear = useWatch({
    control,
    name: `formulaConditions.${index}.targetAmountYear`,
  });

  const disabled = isTrendFieldDisabled(baseAmountYear, targetAmountYear);

  return (
    <SelectField
      name={`formulaConditions.${index}.trendCondition`}
      label={t('amount-search-trend-change')}
      control={control}
      errors={{}}
      width={160}
      options={options}
      disabled={disabled}
      shouldCoexistOnChange
      onChange={(value) => {
        if (value === 'noChange') {
          setValue(`formulaConditions.${index}.trendConditionValue`, null);
        }
      }}
    />
  );
};
